var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h5", { staticClass: "grey-color fw-600" }, [
        _vm._v("Выбор поставщика"),
      ]),
      _c("b-table", {
        staticClass: "table-atmo overflow-hidden mb-2",
        class: { "is-table-invalid": _vm.v && _vm.v.$invalid },
        attrs: {
          fields: _vm.fields,
          items: _vm.proposals,
          small: "",
          responsive: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(index)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "cell(status)",
            fn: function (data) {
              return [
                _vm._v(" " + _vm._s(data.item.status.title) + " "),
                data.item.is_my_proposal
                  ? _c("span", { domProps: { textContent: _vm._s("(Моё)") } })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(created_at)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$formatDateTime(data.item.created_at)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(organization)",
            fn: function (data) {
              return [
                data.item.id === _vm.selectedProposalId
                  ? _c("b-icon-award", {
                      staticStyle: { color: "var(--orange)" },
                      attrs: { title: "Выбран победителем" },
                    })
                  : _vm._e(),
                _vm._v("  "),
                _c(
                  "router-link",
                  {
                    staticClass: "atmo-button-link",
                    attrs: {
                      target: "_blank",
                      to: {
                        name: "OrganizationShow",
                        params: { id: data.item.organization.id },
                      },
                    },
                  },
                  [_vm._v(_vm._s(data.item.organization.name))]
                ),
              ]
            },
          },
          {
            key: "cell(rating)",
            fn: function (data) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm.$formatPrice(data.item.organization.rating)) +
                    " "
                ),
              ]
            },
          },
          {
            key: "cell(actions)",
            fn: function (data) {
              return [
                _c("action-button-small", {
                  attrs: {
                    icon: "clipboard-check",
                    title: "Информация о подписи",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showSign(false, data.item.signature)
                    },
                  },
                }),
                data.item.signature.poa_number &&
                data.item.signature.poa_check_link
                  ? _c("action-button-small", {
                      staticClass: "ml-1",
                      attrs: {
                        icon: "clipboard-plus",
                        title: "Информация о МЧД",
                        variant: "warning",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showSign(false, data.item.signature)
                        },
                      },
                    })
                  : _vm._e(),
                _c("action-button-small", {
                  staticClass: "ml-1",
                  attrs: {
                    icon: "cloud-download",
                    title: "Скачать xml файл",
                    variant: "outline",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.downloadXml(
                        data.item.signature.xml,
                        false,
                        `proposal_${data.item.id}`
                      )
                    },
                  },
                }),
                _c(
                  "b-button",
                  {
                    staticClass:
                      "btn-card-action btn-card-action-green text-uppercase ml-1",
                    staticStyle: {
                      height: "24px",
                      "padding-top": "5px !important",
                      "padding-bottom": "5px !important",
                    },
                    attrs: {
                      disabled: data.item.id === _vm.selectedProposalId,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectProposal(data.item.id)
                      },
                    },
                  },
                  [_vm._v("Выбрать")]
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-form-invalid-feedback",
        { attrs: { state: _vm.v && !_vm.v.$invalid } },
        [_vm._v("Необходимо выбрать поставщика")]
      ),
      _vm.signData.signature
        ? _c("show-sign-modal", {
            attrs: {
              signature: _vm.signData.signature,
              "org-is-customer": _vm.signData.isCustomer,
              show: _vm.showSignModal,
            },
            on: {
              close: function ($event) {
                _vm.showSignModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }